module.exports = __webpack_public_path__ + "static/media/cbse2024.a7b1856f.jpeg";